import { RoomPassengers } from "shared/types/hotels";

export const calculateTotalTravelers = (
  currentRooms: RoomPassengers[],
  guests = 0
): number => {
  return guests;

  // Preparation for CBT integration
  /* if (!currentRooms || currentRooms.length === 0) {
    return 0;
  }

  return currentRooms.reduce((total, room) => {
    const adults = (room.ADT as number) || 0;
    const children = (room.CHD as number) || 0;
    return total + adults + children;
  }, 0); */
};
